// extracted by mini-css-extract-plugin
export default {"root":"Money-module__root___jRyq5","label":"Money-module__label___lz-wF"};